import React from "react";
import InputForm from "../../../components/Input/InputForm";
import InputDateForm from "../../../components/Input/InputDateForm";
import { withStyles } from "@material-ui/core";
import { inject, observer } from "mobx-react";
import { ReactSelect } from "../../../components/Select/SelectSearch";

const options = [
  { label: "Feminino", value: "FEMININO" },
  { label: "Masculino", value: "MASCULINO" },
];

const Participantes = observer(
  ({ classes, participante, sexo, campo, exameStore, idPrefix }) => {
    const getParticipanteValue = (field) => {
      return exameStore?.exame?.[field] || "";
    };

    const handleChange = (event, field) => {
      exameStore.exame[field] = event;
    };

    return (
      <div className={classes.wrapper}>
        <div>
          <label className={classes.label}>Participante:</label>
          <InputForm
            classes={{ input: classes.input }}
            placeholder={participante}
            disabled={true}
          />
        </div>
        <div>
          <label className={classes.label}>Nome do participante :</label>
          <InputForm
            id={`${idPrefix}-inp-nom`}
            classes={{ input: classes.input }}
            onChange={(event) =>
              handleChange(event?.target?.value, `nome${campo}`)
            }
            value={getParticipanteValue(`nome${campo}`)}
          />
        </div>
        <div>
          <label className={classes.label}>Data de nascimento:</label>
          <InputDateForm
            id={`${idPrefix}-inp-dtn`}
            classes={{ input: classes.input }}
            onChange={(event) => handleChange(event, `dataNasc${campo}`)}
            value={getParticipanteValue(`dataNasc${campo}`)}
          />
        </div>
        <div className={classes.containerSelect}>
          <label className={classes.label}>Sexo:</label>
          <ReactSelect
            id={`${idPrefix}-sel-sex`}
            disabled={participante !== "Filho"}
            classes={{ input: classes.input }}
            placeholder={sexo}
            options={options}
            onChange={(event) => handleChange(event, `sexo${campo}`)}
            value={
              participante !== "Filho"
                ? { label: sexo, value: sexo }
                : getParticipanteValue(`sexo${campo}`)
            }
            isDisabled={participante !== "Filho"}
          />
        </div>
      </div>
    );
  }
);

const styles = {
  content: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  wrapper: {
    display: "flex",
    gap: "10px",
  },
  label: {
    fontSize: "10px",
    color: "#868686",
  },
  input: {
    background: "#f2f2f2",
    border: "none",
    paddingTop: "6px !important",
    color: "#505050",
  },
  containerSelect: {
    display: "flex",
    flexDirection: "column",
    minWidth: "100px",
    justifyContent: "center",
  },
};

const ParticipantesWithStyles = withStyles(styles)(Participantes);
const stores = ["exameStore"];
export default inject(...stores)(ParticipantesWithStyles);
